import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { deepLinkToRoute, parseDeepLink } from '@/desktop/deep-links';
import { getElectronAPI, isElectron } from '@/utils/platform';

/** Wire trove:// deep links from the Electron main process into React Router. */
export function useDesktopDeepLinks(): void {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isElectron()) return;
    const api = getElectronAPI();
    if (!api?.onDeepLink) return;

    const unsubscribe = api.onDeepLink((url) => {
      const parsed = parseDeepLink(url);
      if (parsed) {
        navigate(deepLinkToRoute(parsed));
      }
    });

    return unsubscribe;
  }, [navigate]);
}
